import requests from './httpService';

const CategoryService = {
  getAllCategory() {
    return requests.get('/category/list');
  },
  getCategory(body) {
    return requests.post('/category/get', body);
  },
  createCategory(body) {
    return requests.post('/category/add', body);
  },
  getCategoryById(id) {
    return requests.get(`/category/${id}`);
  },
  deleteCategory(body) {
    return requests.delete(`/category/${body._id}`);
  },
  updateCategory(body) {
    return requests.put(`/category/${body._id}`, body);
  },
  addAllCategory(body) {
    return requests.post('/category/all', body);
  },
};

export default CategoryService;

